import React, {useEffect, useRef, useState} from "react";
import axios from '../../services/axiosInstance';
import {BiCaretDown} from "react-icons/bi";
import domesticPickup from "../../assets/img/domesticPickup.png";
import commonSearch from "../../assets/img/commonSearch.png";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import withAuth from "../../auth/UserRouteAuth";
import DaumPostcode from "react-daum-postcode";
import {async} from "sockjs-client";
import {useWebSocket} from "../../services/WebsocketContext";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserPickupRequestPg() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [theme] = useTheme();

    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const [memberInfo, setMemberInfo] = useState([]);
    const findMember = (() => {
        axios({
            method: 'get',
            url: '/member/findMember',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                setMemberInfo(response.data)
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        if (LCAT || SSAT) {
            findMember();
        }
    }, [LCAT, SSAT])


    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!memberInfo.mbNum || isSubscribedRef.current) return;
            if (!stompClient && !isConnected) {
                await websocketConnect(memberInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                isSubscribedRef.current = false;
            }
        };

    }, [memberInfo.mbNum, isConnected, stompClient]);


    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [addressDt, setAddressDt] = useState("");
    const [telnum, setTelnum] = useState("");
    const [wid, setWid] = useState('');
    const [ver, setVer] = useState('');
    const [hei, setHei] = useState('');
    const [realWeight, setRealWeight] = useState('');
    const [isOpenPost, setIsOpenPost] = useState(false);

    const [nameError, setNameError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [addressDtError, setAddressDtError] = useState(false);
    const [telnumError, setTelnumError] = useState(false);
    const [volumeWeightError, setVolumeWeightError] = useState(false);
    const [realWeightError, setRealWeightError] = useState(false);

    const [isRequestBtLoading, setIsRequestBtLoading] = useState(false);
    const [requestFail, setRequestFail] = useState(false);


    const handleNameChange = (e) => {
        setNameError(false);
        setName(e);
    };

    const handleAddressChange = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';
        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress ? ', ' + data.buildingName : data.buildingName);
            }
            fullAddress += (extraAddress ? ' (' + extraAddress + ')' : '');
        }
        setAddress(fullAddress);
        setAddressError(false);
        setIsOpenPost(false);
    };

    const handleAddressDtChange = (e) => {
        setAddressDtError(false);
        setAddressDt(e);
    };

    function formatTelnum(value) {
        if (!value) return "";
        // 숫자만 추출
        value = value.replace(/[^0-9]/g, "");
        const len = value.length;

        if (len === 10) {
            // 3-3-4 (031-711-2222)
            return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        }
        if (len === 11) {
            // 3-4-4 (010-1234-5678, 031-1234-5678)
            return value.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        }
        if (len === 12) {
            // 4-4-4 (0507-1234-5678)
            return value.replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3");
        }
        // 입력중일 때(아직 자리수 부족)
        if (len <= 3) return value;
        if (len <= 7) return value.replace(/(\d{3})(\d{0,4})/, "$1-$2");
        if (len <= 10) return value.replace(/(\d{3})(\d{3,4})(\d{0,4})/, "$1-$2-$3");
        if (len <= 12) return value.replace(/(\d{4})(\d{0,4})(\d{0,4})/, "$1-$2-$3");

        // 12자리 초과 입력시(입력 제한)
        return value.slice(0, 12);
    }

    const handleTelnumChange = (e) => {
        setTelnumError(false);
        const onlyNum = e.replace(/[^0-9]/g, "").slice(0, 12);
        setTelnum(onlyNum);
    };

    const handleWidChange = (e) => {
        setVolumeWeightError(false);
        setWid(e);
    };

    const handleVerChange = (e) => {
        setVolumeWeightError(false);
        setVer(e);
    };

    const handleHeiChange = (e) => {
        setVolumeWeightError(false);
        setHei(e);
    };

    const handleRealWeightChange = (e) => {
        setRealWeightError(false);
        setRealWeight(e);
    };


    const validation = (() => {
        if (!name) {
            setNameError(true);
            return false;
        }
        if (!address) {
            setAddressError(true);
            return false;
        }
        if (!addressDt) {
            setAddressDtError(true);
            return false;
        }
        if (!telnum) {
            setTelnumError(true);
            return false;
        }
        if (!wid) {
            setVolumeWeightError(true);
            return false;
        }
        if (!ver) {
            setVolumeWeightError(true);
            return false;
        }
        if (!hei) {
            setVolumeWeightError(true);
            return false;
        }
        if (!realWeight) {
            setRealWeightError(true);
            return false;
        }
        return true;
    })

    const savePickup = async () => {
        setIsRequestBtLoading(true);
        if (validation()) {
            axios({
                method: 'post',
                url: '/pickup/savePickup',
                data: {
                    memberDTO: memberInfo,
                    name: name,
                    address: address,
                    addressDt: addressDt,
                    telnum: telnum,
                    type: '1',
                    status: '0',
                    wid: wid,
                    ver: ver,
                    hei: hei,
                    realWeight: realWeight,
                }
            })
                .then(async (res) => {
                    await stompClient.send("/app/pickupAlarm", {}, JSON.stringify({sendFl: true}));
                    navigate("/UserPickupRequestComplPg");
                })
                .catch((error) => {
                    setIsRequestBtLoading(false);
                    setRequestFail(true);
                    setTimeout(() => setRequestFail(false), 2000);
                    console.log("신청실패 : ", error)
                })
        } else {
            setIsRequestBtLoading(false);
        }
    }

    const [shipFee, setShipFee] = useState(null);
    const selectedDomeShipFee = async () => {
            axios({
                method: 'post',
                url: '/pickup/selectedDomeShipFee',
                data: {
                    wid: wid,
                    ver: ver,
                    hei: hei,
                    realWeight: realWeight,
                }
            })
                .then(async (res) => {
                    const data = res.data;
                    setShipFee(data);
                })
                .catch((error) => {
                    console.log("국내배송료 조회실패 : ", error)
                })
        }

    useEffect(() => {
        if (wid && ver && hei && realWeight) {
            selectedDomeShipFee();
        }
    }, [wid, ver, hei, realWeight]);





    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-form-card">
                <div className="up-form-head">
                    <img className="up-invert" src={domesticPickup} alt="header"/>
                    <p className="t">{t('upr1')}</p>
                </div>

                <div className="up-card" style={{padding: "28px 26px"}}>
                    {/*성함*/}
                    <div className="up-field">
                        <input onChange={(e) => handleNameChange(e.target.value)} type="text" className="up-input"
                               placeholder={t('upr2')} value={name} maxLength={20}/>
                    </div>
                    {nameError && <div className="up-err">{t('upr3')}</div>}

                    {/*주소*/}
                    <div className="up-field" style={{position: "relative"}}>
                        <input
                            onClick={() => setIsOpenPost(true)}
                            onChange={(e) => setAddress(e.target.value)}
                            type="text"
                            className="up-input"
                            style={{paddingRight: "42px", cursor: "pointer"}}
                            placeholder={t('upr4')}
                            value={address}
                            maxLength={300}
                            readOnly
                        />
                        <div onClick={() => setIsOpenPost(true)}
                             style={{position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer"}}>
                            <img className="up-invert" src={commonSearch} alt="search"
                                 style={{width: "22px", height: "22px", opacity: 0.6}}/>
                        </div>
                    </div>
                    {addressError && <div className="up-err">{t('upr5')}</div>}

                    {isOpenPost && (
                        <div style={{
                            position: "fixed", left: 0, top: 0, width: "100vw", height: "100vh",
                            background: "rgba(0,0,0,0.5)", zIndex: 9999,
                            display: "flex", alignItems: "center", justifyContent: "center", padding: "12px"
                        }}>
                            <div style={{background: "#fff", padding: "16px", borderRadius: "14px", maxWidth: "94vw"}}>
                                <DaumPostcode
                                    onComplete={handleAddressChange}
                                    autoClose
                                    style={{width: "100%", maxWidth: 400, height: 450}}
                                />
                                <button
                                    className="up-btn-primary"
                                    style={{marginTop: "10px", width: "100%", height: "40px", fontSize: "14px"}}
                                    onClick={() => setIsOpenPost(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}

                    {/*상세주소*/}
                    <div className="up-field">
                        <input onChange={(e) => handleAddressDtChange(e.target.value)} type="text"
                               className="up-input" placeholder={t('upr6')} value={addressDt} maxLength={50}/>
                    </div>
                    {addressDtError && <div className="up-err">{t('upr7')}</div>}

                    {/*연락처*/}
                    <div className="up-field">
                        <input
                            onChange={e => handleTelnumChange(e.target.value)}
                            type="text"
                            className="up-input"
                            placeholder={t('upr8')}
                            value={formatTelnum(telnum)}
                            maxLength={14}
                            inputMode="numeric"
                            pattern="\d*"
                            autoComplete="tel"
                        />
                    </div>
                    {telnumError && <div className="up-err">{t('upr9')}</div>}

                    {/*부피&무게 (가로/세로/높이)*/}
                    <div style={{display: "flex", gap: "8px", marginTop: "12px"}}>
                        <input onChange={e => handleWidChange(e.target.value)} type="text" className="up-input"
                               style={{flex: "1 1 0", minWidth: 0}} placeholder={t('upr10')} value={wid}
                               maxLength={3} inputMode="numeric" pattern="\d*" autoComplete="tel"/>
                        <input onChange={e => handleVerChange(e.target.value)} type="text" className="up-input"
                               style={{flex: "1 1 0", minWidth: 0}} placeholder={t('upr11')} value={ver}
                               maxLength={3} inputMode="numeric" pattern="\d*" autoComplete="tel"/>
                        <input onChange={e => handleHeiChange(e.target.value)} type="text" className="up-input"
                               style={{flex: "1 1 0", minWidth: 0}} placeholder={t('upr12')} value={hei}
                               maxLength={3} inputMode="numeric" pattern="\d*" autoComplete="tel"/>
                    </div>
                    {volumeWeightError && <div className="up-err" style={{marginTop: "8px"}}>{t('upr13')}</div>}

                    {/*실무게*/}
                    <div className="up-field" style={{marginTop: "10px"}}>
                        <input
                            onChange={e => {
                                // 정수 또는 소수점 1개만 허용
                                const val = e.target.value;
                                if (val === '' || /^[0-9]*\.?[0-9]*$/.test(val)) {
                                    handleRealWeightChange(val);
                                }
                            }}
                            type="text"
                            className="up-input"
                            placeholder={t('upr14')}
                            value={realWeight}
                            maxLength={6}
                            inputMode="decimal"
                            autoComplete="off"
                        />
                    </div>
                    {realWeightError && <div className="up-err">{t('upr15')}</div>}

                    <div className="display-flex align-center justify-content-between font-s-14"
                         style={{background: "var(--up-brand-soft)", borderRadius: "10px", padding: "12px 14px", marginTop: "6px"}}>
                        <span style={{color: "var(--up-brand-2)", fontFamily: "'LINESeedKR-Bd', sans-serif"}}>{t('upr16')}</span>
                        <span style={{color: "var(--up-brand-2)", fontFamily: "'LINESeedKR-Bd', sans-serif"}}>
                            {shipFee?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') || 0}
                        </span>
                    </div>

                    {/*버튼*/}
                    <button onClick={savePickup} className="up-btn-primary" style={{width: "100%", height: "48px", fontSize: "15px", marginTop: "18px"}}>
                        {isRequestBtLoading ? (
                            <div className="up-spin"></div>
                        ) : (
                            <span>{t('upr17')}</span>
                        )}
                    </button>
                    {requestFail &&
                        <div className="up-err" style={{textAlign: "center", marginTop: "10px"}}>{t('umiErr4')}! &#128514;</div>
                    }
                </div>
            </div>
        </div>
    )
}

export default withAuth(UserPickupRequestPg)
